(function($){

  /**
   * モーダルウィンドウコンテンツ
   */
  $.fn.modal = function(arg) {
    // 初期設定
    var defaults = {
      closeButton: $(),
      beforeShowCallback: function(){},
      shownCallback: function(){}
    };

    // センタリングを実行する関数
    function centeringModalSyncer($content){
      // 画面(ウィンドウ)の幅、高さを取得
      var w = $(window).width();
      var h = $(window).height();

      // コンテンツ(#modal-content)の幅、高さを取得
      var cw = $content.outerWidth(true);
      var ch = $content.outerHeight(true);

      // センタリングを実行する
      $content.css({"left": ((w - cw)/2) + "px","top": ((h - ch)/2) + "px"});
    }

    // 公開メソッド
    var methods = {
      // 初期処理
      init: function(options) {
        var $this = $(this);
        var settings = $.extend({}, defaults, options);
        $(this).addClass("modal-content").data("modal",{
          target: $this,
          settings: settings
        });
        // リサイズされたら、センタリングをする関数[centeringModalSyncer()]を実行する
        $(window).resize(function(){centeringModalSyncer($this);});
      },
      show: function() {
        var $this = $(this);
        var settings = $this.data("modal").settings;
        settings.beforeShowCallback.apply($this);
        //オーバーレイを出現させる
        var $overlay = $('<div class="modal-overlay"></div>').appendTo("body");
        $overlay.fadeIn("fast");
        //コンテンツをセンタリングする
        centeringModalSyncer($this);
        //コンテンツをフェードインする
        $this.fadeIn("fast", function(){settings.shownCallback.apply($this, arguments);});
        //[#modal-overlay]、または[#modal-close]をクリックしたら…
        $overlay.add(settings.closeButton).off().click(function(){
          //[#modal-content]と[#modal-overlay]をフェードアウトした後に…
          $this.add($overlay).fadeOut("fast",function(){
            //[#modal-overlay]を削除する
            $overlay.remove();
          });
        });
      }
    };

    // メソッド呼出
    if ( methods[arg] ) {
      // 第一引数がメソッド名の場合、引数からメソッド名を削除して呼出
      return methods[arg].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof arg === 'object' || !arg) {
      // 第一引数がオブジェクトの場合、引数をそのまま初期処理を呼出
      return methods.init.apply(this, arguments);
    } else {
      // 該当しない場合エラー
      $.error( 'Option ' +  arg + ' does not exist on jQuery.modal' );
    }

    return this;
  }

})(jQuery);
